import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class RegistrationStammdatenIncompleteError extends ExpectedError {
  static override _class = 'RegistrationStammdatenIncompleteError';

  public constructor() {
    super('RegistrationStammdatenIncompleteError', { translationKey: 'REGISTRATION_STAMMDATEN_INCOMPLETE_ERROR' });
  }
}
